import WIDGET_ITEMS_MAP from '../items/widgets';
import APP_ITEMS from '../items/apps';
import { useMenu, useProduct } from '@/store';
import type { TItem } from '@/components/GridBoards/types';
import {
  createWidget,
  createThirdApp,
  createApp,
  createShortcut,
} from '../layoutItems';

type ReturnOfUsePickers = [TItem[], (arg: TItem[]) => void];

const usePickers = (
  screen: number,
  siderbounds: LayoutBoxSiderbounds,
): ReturnOfUsePickers => {
  const [{ builtinApp = [], thirdApp = [] }, updateMenu] = useMenu();
  const [product] = useProduct();

  // apps
  const apps: TItem[] = Object.values(APP_ITEMS)
    .filter((ap) => {
      const matched = builtinApp?.find((ba) => ba.apkName === ap.apkName);
      if (!matched) return false;
      return matched.hide === 1;
    })
    .map((a) => {
      return createApp(
        {
          ...a,
          x: -1,
          y: -1,
        },
        siderbounds,
      );
    });

  // thirdapp
  const thirdapps: TItem[] = thirdApp
    .filter(({ hide }) => hide === 1)
    .map((tha) => {
      const className = tha.className;
      const title = tha.displayName;

      return createThirdApp(
        {
          className,
          title,
        },
        siderbounds,
      );
    });

  // widgets
  const widgets: TItem[] = Object.values(WIDGET_ITEMS_MAP[product]).map(
    (wd) => {
      return createWidget(
        {
          className: wd.className,
        },
        product,
        siderbounds,
      );
    },
  );

  // shortcut
  const shortcut: TItem[] =
    product === 'gac2570' ? [] : [createShortcut({ screen }, siderbounds)];

  /**
   * 修改menu中的hide值
   */
  const updatePickers = (items: TItem[]) => {
    const builtinTmp: PropType<ConfigMenu, 'builtinApp'> = [];
    const thirdTmp: PropType<ConfigMenu, 'thirdApp'> = [];
    items.forEach((i) => {
      const _id = i!.id as keyof typeof APP_ITEMS;
      if (APP_ITEMS[_id]) {
        builtinTmp.push({
          apkName: APP_ITEMS[_id].apkName,
          className: APP_ITEMS[_id].className,
          packageName: APP_ITEMS[_id].packageName,
          hide: 1,
        });
        return false;
      }
      const matchedThirdApp = thirdApp.find((tha) => tha.className === i!.id);
      if (matchedThirdApp) {
        thirdTmp.push({
          ...matchedThirdApp,
          hide: 1,
        });
      }
    });

    const _builtinApp = builtinApp
      .filter(
        (ba) => builtinTmp.findIndex((bt) => bt.apkName === ba.apkName) === -1,
      )
      .map((ba) => {
        return {
          apkName: ba.apkName,
          className: ba.className,
          packageName: ba.packageName,
          hide: 0 as 0 | 1,
        };
      });

    const _thirdApp = thirdApp
      .filter(
        (tha) =>
          thirdTmp.findIndex((tht) => tht.className === tha.className) === -1,
      )
      .map((tha) => {
        return {
          ...tha,
          hide: 0 as 0 | 1,
        };
      });

    updateMenu({
      builtinApp: [..._builtinApp, ...builtinTmp],
      thirdApp: [..._thirdApp, ...thirdTmp],
    });
  };

  return [[...apps, ...thirdapps, ...widgets, ...shortcut], updatePickers];
};

export default usePickers;
